import { Navigate } from 'react-router-dom';
import useAuthStore from '../../stores/authStore';

/**
 * PrivateRoute - Requires authentication
 * Redirects to /login if not authenticated
 */
const PrivateRoute = ({ children }) => {
  const { isAuthenticated } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;
